import { render, staticRenderFns } from "./forsta-copy-paste-script-widget.vue?vue&type=template&id=8f0461fc"
import script from "./forsta-copy-paste-script-widget.vue?vue&type=script&lang=js"
export * from "./forsta-copy-paste-script-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports